<template>
  <div id="form">
    <!--    <div class="bg-color-black">-->
    <div class="d-flex pt-2 pl-2">
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">科技孵化类平台</span>
        </span>
    </div>
    <!--    <div class="up">-->
    <div class="d-flex" style="width: 100%;height: 90%;margin-top: 0.5rem">
      <Echart
          id="mallChart2"
          :options="options"
          height="100%"
          width="100%"
      ></Echart>

    </div>

    <!--    </div>-->

  </div>
  <!--  </div>-->
</template>

<script>
import Echart from '@/common/echart'
// import sciApi from '@/api/index.js'
let Chart
export default {
  data () {
    return {
      options: {},
      tag:'',
      Index:null,
      val:[],
      Num:{},
      title:[
        '申报通知',
        '官方解读',
        '公示名录',
        '政府文件',
        '政策精要',],
      deList:[],
      tagList:{}
      // 通过率和达标率的组件复用数据
    };
  },
  watch: {
    // setpolicy:{
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     this.Index=val
    //     console.log(this.Index,'999')
    //     this.init().then(() => {
    //       let num=[]
    //       for(var i=0;i<this.val.length;i++){
    //         if (this.val[i].name !=='政策'){
    //           num.push(this.val[i])
    //         }
    //       }
    //       this.options.series[0].data= num
    //       Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    //     })
    //   }
    // },
    setregion2: {
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val
      }
    },
    setData: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log(val, 'val')
        // if(!Chart.clear) return
        // Chart.clear()
        this.tagList=val
        this.init().then(() => {
          let num=[]
          for(var i=0;i<this.val.length;i++){
            if (this.val[i].name !=='政策'){
              num.push(this.val[i])
            }
          }
          this.options.series[0].data= num
          Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
        })
      }
    }
  },
  computed: {
    setregion2() {
      // console.log(this.$store.state.region)
      return this.$store.state.region2
    },
    setpolicy() {
      // console.log(this.$store.state.region)
      return this.$store.state.now
    },
    setData() {
      // console.log(this.$store.state.carList,'this.$store.state.carList')
      return this.$store.state.carList
    },
  },
  mounted() {
    this.tag=''
    this.Index=null
    this.init().then(()=>{
      let num=[]
      for(var i=0;i<this.val.length;i++){
        if (this.val[i].name !=='政策'){
          num.push(this.val[i])
        }
      }
      this.options.series[0].data= num
      Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    })
    //当前视口宽度
    let nowClientWidth = document.documentElement.clientWidth;
    // 换算方法
    let nowSize = function (val, initWidth = 1920) {
      return val * (nowClientWidth / initWidth);
    };
    this.options = {
      color: [
        "#37a2da",
        "#32c5e9",
        "#9fe6b8",
        "#ffdb5c",
        "#ff9f7f",
        "#fb7293",
        "#e7bcf3",
        "#8378ea"
      ],
      tooltip: {
        trigger: 'item',
        // formatter: "{b}<br/>{c}家"
        backgroundColor:'#fff',
        textStyle:{
          color:'#000'
        }
      },
      legend: {
        show:false,
        orient: 'vertical',
        left:'left',
      },
      series: [
        {
          name: '科技孵化类平台',
          type: 'pie',
          // roseType: "area",
          radius: ['50%', '80%'],
          center: ["50%", "50%"],
          avoidLabelOverlap: true,
          label: {
            fontSize:nowSize(13),
            show: true,
            // position: 'outer',
            // alignTo: 'labelLine',
            formatter: "{number|{c}家}\n{b}",
            rich: {
              number: {
                // fontSize: 16,
                fontSize:nowSize(16),
                color: '#fff',
              }
            }
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: '28',
          //   }
          // },
          data: [],
        }
      ]
    }
    this.drawLine()
  },
  methods:{
    async init(){
      // const that = this;
      // await sciApi.selectCarrier({}).then((data)=>{
        // data 就是接口返回值
        this.deList = this.tagList.incubation_platform|| []
        this.val=[]
        this.deList.forEach((item) => {
          this.Num[item.platformTypeDisplay]=item
        })
        let names = Object.keys(this.Num)
        names.forEach(()=>{
          this.val.push({name:'政策',value:0})
        })
        console.log(names,'names')
        // 累加数据
        this.deList.forEach((item) => {
          // console.log(item,'item')
          let idx = names.indexOf(item.platformTypeDisplay)
          if (idx != -1) {
            // 首次全部累加
            // if(this.tag!==''){
            //   if(item.townStreetDisplay == this.tag){
                if(item.platformTypeDisplay.indexOf('年')<0) {
                  this.val[idx].name = names[idx] || '政策'
                  this.val[idx].value = item.num||0
                }
            //   }else {
            //     if(item.platformTypeDisplay.indexOf('年')<0) {
            //       this.val[idx].name = names[idx] || '政策'
            //       this.val[idx].value = 0
            //     }
            //   }
            // }else {
            //   if(item.platformTypeDisplay.indexOf('年')<0) {
            //     this.val[idx].name = names[idx] || '政策'
            //     this.val[idx].value += Number(item.num||0 )
            //   }
            // }
            // 非首次则只累加某个类目
            // if(this.Index!=null && item.level1Display==this.title[this.Index]) {
            //   this.val[idx].name = names[idx] || '政策'
            //   this.val[idx].value += Number(item.mapNum||0 )
            // }
          }
        // })
        // console.log(this.val,'val')
      })
    },
    drawLine:function (){
      //基于准备好的dom，初始化echarts实例
      Chart = this.$echarts.init(document.getElementById('mallChart2'))
      Chart.setOption(JSON.parse(JSON.stringify(this.options)));
    },
  },

  components: {
    Echart
  }
};
</script>

<style lang="scss" scoped>
#form {
  height:100%;
  width: 100%;
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-around;
    .item {
      float: left;
      border-radius: 0.0625rem;
      padding-top: 0.2rem;
      margin-top: 0.1rem;
      width: 50%;
      height: 0.875rem;
    }
  }
  .down {
    padding: 0.07rem 0.05rem;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 3.1875rem;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 0.0625rem;
    }
    .ranking {
      padding: 0.125rem;
      width: 59%;
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 1.5rem;
        span {
          margin-top: 0.0875rem;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
      }
    }
  }
}
</style>